import { render } from "./DataExploration.vue?vue&type=template&id=37e956a4"
import script from "./DataExploration.vue?vue&type=script&lang=js"
export * from "./DataExploration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__